import { memo } from 'react';
import { Box, Button, CircularProgress, Grid, Skeleton } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SendIcon from '@mui/icons-material/Send';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import LogoOne7Ai from 'assets/img/logo_one7_ai.png';
import useNovaCessaoHook from '../hooks/useNovaCessaoHook';
import FiltrosTabela from '../componentes/FiltrosTabela/FiltrosTabela';
import './NovaCessao.scss';
import LoadingBox from '../componentes/LoadingBox/LoadingBox';
import SimulacaoBox from '../componentes/SimulacaoBox/SimulacaoBox';
import InputsSessao from '../componentes/InputsCessao/InputsSessao';
import FooterTabela from '../componentes/FooterTabela/FooterTabela';
import TabsSimulacao from '../componentes/TabsSimulacao/TabsSimulacao';
import SkeletonLoadingOverlay from '../componentes/SkeletonTabela/SkeletonTabela';
import ModalCancelarCessao from '../componentes/ModalCancelarCessao/ModalCancelarCessao';
import ModalTitulosCedidos from '../componentes/ModalTitulosCedidos/ModalTitulosCedidos';

const NovaCessao = ({ escopoAcesso, setEscopoAcesso, setCarregarTela }) => {
  const {
    contadorFiltros,
    valorDisponivel,
    mostrarSimulacao,
    liberarSimulacao,
    loadingProsseguir,
    irParaSugestao,
    toolbarTabela,
    handleFiltrar,
    loading,
    rows,
    columns,
    inputsRef,
    irParaHome,
    simularTaxas,
    paginationModel,
    handlePaginationModelChange,
    loadValorDisponivel,
    rowCount,
    selecionarManualmente,
    setSelecionarManualmente,
    handleRowSelectionModelChange,
    selectedRowsMap,
    rowSelectionModelFiltered,
    openModalCancelar,
    setOpenModalCancelar,
    onCloseModalCancelar,
    handleSortModelChange,
    buscarSimulacaoResumo,
    sortModel,
    buscarAtualizarSimulacao,
    liberarBtnProsseguir,
    setLiberarBtnProsseguir,
    openModalTitulosCedidos,
    onCloseModalTitulosCedidos,
    verificaTitulosCedidos
  } = useNovaCessaoHook({
    escopoAcesso,
    setEscopoAcesso,
    setCarregarTela
  });

  return (
    <Grid container className="container-sessao">
      <Grid item xs={12}>
        <Box className="sessao-topo">
          <Box className="subtitulo-sessao">
            <Button className="btn-voltar-sessao" onClick={() => irParaHome()}>
              <KeyboardBackspaceIcon /> voltar
            </Button>
            <Box className="titulo-sessao">Nova cessão</Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="box-limite-disponivel">
          <Box className="box-logo">
            <img src={LogoOne7Ai} className="logo-one-ai" alt="Logo One AI" />
          </Box>

          <Box className="box-conteudo-limite">
            {!mostrarSimulacao && (
              <Box className="titulo-limite-disponivel">
                Deixe que nossa I.A. ajude você a ceder os títulos ideais para liberar seu Saldo em novas
                operações
              </Box>
            )}

            <Box>
              <Grid container className="grid-valores-sessao">
                <Grid item xs={12} md={8}>
                  <InputsSessao
                    ref={inputsRef}
                    valorDisponivel={valorDisponivel}
                    mostrarSimulacao={mostrarSimulacao}
                    loadValorDisponivel={loadValorDisponivel}
                  />
                </Grid>

                <Grid item xs={12} md={4} className="box-limite-card">
                  <Box className="limite-card">
                    <Box className="limite-card-content w-100">
                      <Box className="limite-card-title">Limite disponível</Box>
                      <Box className="limite-card-value">
                        {loadValorDisponivel && (
                          <Skeleton
                            className="skeleton-custom"
                            animation="wave"
                            width="90%"
                            height={55}
                          />
                        )}

                        {!loadValorDisponivel && <>R$ {valorDisponivel}</>}
                      </Box>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} className="box-limite-card">
                  {!mostrarSimulacao && (
                    <Box className="box-btn-procurar">
                      <Button
                        className="button-selcionar-manualmente"
                        onClick={() => setSelecionarManualmente(true)}
                      >
                        Selecione manualmente
                        <DoneAllIcon className="icon-send-btn" />
                      </Button>

                      <Button
                        className="button-procurar-sugestoes"
                        onClick={() => irParaSugestao('sugestao')}
                      >
                        Procurar sugestões com One.ai
                        <SendIcon className="icon-send-btn" />
                      </Button>
                    </Box>
                  )}
                </Grid>

                {mostrarSimulacao && (
                  <Grid container>
                    {!simularTaxas && (
                      <Grid item xs={12} md={4} xl={3} className="grid-simulacao">
                        <Box className="box-loading">
                          <LoadingBox iniciar={mostrarSimulacao} onFim={() => {}} />
                        </Box>
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={12}
                      md={simularTaxas ? 12 : 8}
                      xl={simularTaxas ? 12 : 9}
                      className={`${simularTaxas ? 'box-ajuste-simulacao' : ''}`}
                    >
                      <Grid item xs={12} md={simularTaxas ? 8 : 12}>
                        <Box className="box-simulacao">
                          <SimulacaoBox
                            buscarSimulacaoResumo={buscarSimulacaoResumo}
                            setLiberarBtnProsseguir={setLiberarBtnProsseguir}
                          />
                        </Box>
                      </Grid>
                      <Box className="box-tabs">
                        <TabsSimulacao
                          simularTaxas={simularTaxas}
                          buscarSimulacaoResumo={buscarSimulacaoResumo}
                          buscarAtualizarSimulacao={buscarAtualizarSimulacao}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Box className="box-btns">
                        <Button
                          className="btn-cancelar"
                          disabled={loadingProsseguir}
                          onClick={() => setOpenModalCancelar(true)}
                        >
                          Cancelar
                        </Button>
                        <Button
                          className="btn-voltar"
                          disabled={loadingProsseguir}
                          onClick={() => liberarSimulacao()}
                        >
                          Modificar pedido
                        </Button>
                        <Button
                          className="btn-processeguir-upload"
                          disabled={loadingProsseguir || !liberarBtnProsseguir}
                          onClick={() => verificaTitulosCedidos()}
                        >
                          {!loadingProsseguir && <>Prosseguir com a cessão dos títulos</>}
                          {loadingProsseguir && (
                            <>
                              Prosseguindo com a cessão dos títulos
                              <CircularProgress size={20} color="inherit" />
                            </>
                          )}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
        </Box>

        {!mostrarSimulacao && selecionarManualmente && (
          <Box>
            <Box className="box-data-grid">
              <FiltrosTabela onFiltrar={handleFiltrar} contadorFiltros={contadorFiltros} />
              <Grid container>
                <Grid className="content-datagrid-lista-titulos" item xs={12}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    checkboxSelection
                    loading={loading}
                    className="data-grid-cessao"
                    pageSizeOptions={[10, 25, 50, 100]}
                    disableRowSelectionOnClick
                    rowSelectionModel={rowSelectionModelFiltered}
                    onRowSelectionModelChange={handleRowSelectionModelChange}
                    slots={{
                      toolbar: toolbarTabela,
                      footer: () => <FooterTabela selectedRowsMap={selectedRowsMap} />,
                      loadingOverlay: SkeletonLoadingOverlay
                    }}
                    localeText={{
                      ...ptBR.components.MuiDataGrid.defaultProps.localeText
                    }}
                    paginationMode="server"
                    paginationModel={paginationModel}
                    onPaginationModelChange={handlePaginationModelChange}
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortModelChange}
                    rowCount={rowCount}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box className="box-btn-sessao">
              <Button
                className="btn-processeguir-sessao"
                disabled={loadingProsseguir || Object.keys(selectedRowsMap).length === 0}
                onClick={() => irParaSugestao('simular')}
              >
                {!loadingProsseguir && <>Simular taxas</>}
                {loadingProsseguir && (
                  <>
                    Simulando taxas &nbsp;
                    <CircularProgress className="margin-left-10" size={20} color="inherit" />
                  </>
                )}
              </Button>
            </Box>
          </Box>
        )}
      </Grid>

      <ModalCancelarCessao open={openModalCancelar} onClose={onCloseModalCancelar} />

      <ModalTitulosCedidos
        open={openModalTitulosCedidos}
        onClose={onCloseModalTitulosCedidos}
        setCarregarTela={setCarregarTela}
      />
    </Grid>
  );
};

export default memo(NovaCessao);
